(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-car"] && !Shopify.designMode) return;
  try {
    
(function(){
  const sec  = document.currentScript.closest('.ea');
  const rail = sec.querySelector('.ea__rail');
  const dotsWrap = sec.querySelector('.ea__dots');
  const cards = Array.from(rail.querySelectorAll('.ea-card'));
  if (!rail || cards.length < 2) return;

  // sizes
  const GAP = parseFloat(getComputedStyle(rail).gap) || 24;
  const STEP = () => cards[0].offsetWidth + GAP;

  // build dots to match cards
  dotsWrap.innerHTML = '';
  cards.forEach((_, i) => {
    const dot = document.createElement('button');
    dot.className = 'ea__dot';
    dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
    dot.addEventListener('click', () => { index = i; go(index); pause(); });
    dotsWrap.appendChild(dot);
  });
  const dots = Array.from(dotsWrap.querySelectorAll('.ea__dot'));

  let index = 0, timer = null, playing = true;

  function go(n){
    index = (n + cards.length) % cards.length;
    rail.scrollTo({ left: index * STEP(), behavior: 'smooth' });
    dots.forEach((d,k)=> d.setAttribute('aria-selected', k === index ? 'true' : 'false'));
  }

  function next(){
    const maxLeft = rail.scrollWidth - rail.clientWidth - 1;
    if (rail.scrollLeft >= maxLeft) { index = 0; go(index); return; }
    go(index + 1);
  }

  function start(){ clearInterval(timer); if (!playing) return; timer = setInterval(next, 3500); }
  function pause(ms=6000){ playing = false; clearInterval(timer); setTimeout(()=>{ playing = true; start(); }, ms); }

  // pause on hover (desktop)
  rail.addEventListener('mouseenter', ()=> pause());
  rail.addEventListener('mouseleave', ()=> { playing = true; start(); });

  // init
  go(0); start();

  // AJAX add to cart
  sec.addEventListener('click', async (e)=>{
    const b = e.target.closest('[data-add]'); if(!b) return;
    e.preventDefault();
    const vid = Number(b.getAttribute('data-vid')); if(!vid) return;
    b.disabled = true;
    try{
      const res = await fetch('/cart/add.js',{
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items:[{ id: vid, quantity: 1 }] })
      });
      if(!res.ok) throw await res.json();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      b.textContent = 'Added ✓';
      setTimeout(()=>{ b.textContent = '{{ section.settings.preorder_text }}'; b.disabled = false; }, 900);
    }catch(err){
      alert((err && err.description) || 'Unable to add to cart'); b.disabled = false;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-list"]) return;
  try {
    
document.querySelectorAll('.filter-title').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.parentElement.classList.toggle('open');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero-with-overlay"] && !Shopify.designMode) return;
  try {
    
(function() {
  function openFor(button){
    const root  = button.closest('[id^="shopify-section-"]');
    if (!root) return;
    const modal = root.querySelector('.vh-modal');
    const panel = modal?.querySelector('.vh-modal__panel');
    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    panel && panel.focus();
    document.documentElement.style.overflow = 'hidden';

    // Store focus to restore later
    modal._lastFocus = document.activeElement;

    // Trap focus + Esc to close
    function trap(e){
      if (e.key === 'Escape'){ closeFor(modal); return; }
      if (e.key !== 'Tab') return;
      const f = modal.querySelectorAll('a,button,textarea,input,select,[tabindex]:not([tabindex="-1"])');
      const list = Array.from(f).filter(el => !el.disabled);
      if (!list.length) return;
      const first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first){ last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last){ first.focus(); e.preventDefault(); }
    }
    modal._trap = trap;
    document.addEventListener('keydown', trap);
  }

  function closeFor(modal){
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.removeEventListener('keydown', modal._trap || (()=>{}));
    document.documentElement.style.overflow = '';
    if (modal._lastFocus && typeof modal._lastFocus.focus === 'function'){
      modal._lastFocus.focus();
    }
  }

  // Delegate clicks
  document.addEventListener('click', function(e){
    const openBtn = e.target.closest('.js-vh-open');
    if (openBtn){ e.preventDefault(); openFor(openBtn); return; }

    const closeBtn = e.target.closest('.js-vh-close');
    if (closeBtn){
      const modal = closeBtn.closest('.vh-modal');
      if (modal){ e.preventDefault(); closeFor(modal); }
      return;
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
